import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { PreInitSettingsService } from 'src/app/core/services/settings/pre-init-setting.service';
import { loginRouteWithSlash, myAccountRouteWithSlash } from 'src/app/route-constants';
import { OktaAuth } from '@okta/okta-auth-js';
@Component({
  selector: 'pgh-okta-hosted-login',
  templateUrl: './okta-hosted-login.component.html',
  styleUrls: ['./okta-hosted-login.component.scss']
})
export class OktaHostedLoginComponent implements OnInit {

  private configSettings;

  constructor(@Inject(OKTA_AUTH) private okta: OktaAuth, private router: Router, private preInitAppSettings: PreInitSettingsService) {
    this.configSettings = this.preInitAppSettings.getSettings();
  }

  async ngOnInit(): Promise<void> {
    const oktaSessionExists = await this.okta.session.exists();
    const oktTokenStorage = localStorage.getItem('okta-token-storage');
    if (oktaSessionExists || oktTokenStorage) {
      const tokenDetail = oktaSessionExists ? await this.getToken()
        : (oktTokenStorage ? { isValid: this.isValidateToken(oktTokenStorage), token: JSON.parse(oktTokenStorage) }
          : { isValid: false, token: null });

      if (tokenDetail.isValid) {
        const tokens = tokenDetail.token;
        const idToken = oktaSessionExists ? tokens.tokens.idToken
          : (tokens.id_token ? tokens.id_token : tokens.idToken);

        const accessToken = oktaSessionExists ? tokens.tokens.accessToken
          : (tokens.access_token ? tokens.access_token : tokens.accessToken);

        const token = oktaSessionExists ? tokens.tokens.accessToken.accessToken
          : (tokens.access_token && tokens.access_token.accessToken ? tokens.access_token.accessToken
            : tokens.accessToken.accessToken);

        const decodedToken = this.okta.token.decode(token);
        let isExists = false;
        // Check exist in group or not
        if (decodedToken && decodedToken.payload && Array.isArray(decodedToken.payload.groups)) {
          // Check if groups array has length and perform further operations
          if (decodedToken.payload.groups.length > 0) {
            isExists = decodedToken.payload.groups.some(x =>
              x.toString().toLowerCase().trim() === this.preInitAppSettings.getSiteSettings().groupName.toLowerCase().trim()
            );
          }
        }

        let isTokenExpired = false;
        if (decodedToken?.payload?.exp) {
          const expiryDate = new Date(decodedToken?.payload?.exp * 1000);
          const now = new Date();
          if (now > expiryDate) {
            isTokenExpired = true;
          }
        }

        if (isExists && !isTokenExpired) {
          this.okta.tokenManager.add('id_token', idToken);
          this.okta.tokenManager.add('access_token', accessToken);
          this.router.navigate([myAccountRouteWithSlash]);
        } else {
          this.okta.signInWithRedirect().then(
            _ => this.router.navigate([loginRouteWithSlash])
          );
        }
      } else {
        this.okta.signInWithRedirect().then(
          _ => this.router.navigate([loginRouteWithSlash])
        );
      }
    } else {
      this.okta.signInWithRedirect().then(
        _ => this.router.navigate([loginRouteWithSlash])
      );
    }
  }

  async getToken() {
    return this.okta.token.getWithoutPrompt({
      scopes: this.configSettings.okta.scopes,
      issuer: this.configSettings.okta.issuer
    }).then((res) => {
      return Promise.resolve({ isValid: true, token: res });
    }).catch(err => {
      return Promise.resolve({ isValid: false, token: null });
    });
  }

  isValidateToken(oktTokenStorage: string) {
    const tokens = JSON.parse(oktTokenStorage);
    try {
    const idToken = tokens.id_token ? tokens.id_token : tokens.idToken;
    const accessToken = tokens.access_token ? tokens.access_token : tokens.accessToken;
    const token = tokens.access_token && tokens.access_token.accessToken ? tokens.access_token.accessToken
      : (tokens.accessToken ? tokens.accessToken.accessToken : null);
    let isValid = false;
    if (idToken && accessToken && token) {
      isValid = true;
    }
    return isValid;
    } catch  {
      return false;
    }
  }
}

